import { FC } from 'react';
import {
  Button,
  Spacer,
  TextTitle,
  Icon,
  TextBody,
  Input,
  Stack,
} from '@pypestream/design-system';

import { GenericModal, GenericModalProps } from '..';

export type ConnectAiProviderModalProps = GenericModalProps & {
  provider?: 'gemini' | 'open-ai' | 'anthropic';
  type?: 'connect' | 'edit';
};

const providerData = {
  gemini: {
    icon: 'gemini',
    title: 'your Google Cloud Project',
    description: (
      <span>
        access to Google Gemini models by providing a name and API key for this
        provider. This setup is required to use Gemini in your solutions.{' '}
        <a href="#">Gemini API docs & quickstart</a>
      </span>
    ),
  },
  'open-ai': {
    icon: 'gpt',
    title: 'your OpenAI account',
    description:
      'access to OpenAI models by providing a name and API key. This setup is required to use OpenAI in your solutions.',
  },
  anthropic: {
    icon: 'claude',
    title: 'your Anthropic account',
    description:
      'access to Anthropic models by providing a name and API key. This setup is required to use Anthropic in your solutions.',
  },
};

export const ConnectAiProviderModal: FC<ConnectAiProviderModalProps> = ({
  modalRef,
  onClose,
  provider = 'gemini',
  type = 'connect',
}) => {
  const isEdit = type === 'edit';

  return (
    <GenericModal
      test-id="load-as-draft-modal"
      modalRef={modalRef}
      onClose={onClose}
      size="large"
    >
      <Stack justifyContent="center">
        <Icon
          // @ts-expect-error Icon name type issue
          name={providerData[provider].icon}
          size="xlarge"
        ></Icon>
      </Stack>
      <Spacer size="xlarge" />
      <TextTitle size="small" textAlign="center">
        {isEdit ? 'Edit' : 'Connect'} {providerData[provider].title}
      </TextTitle>
      <Spacer size="small" />
      <TextBody variant="secondary" textAlign="center">
        {isEdit ? 'Edit' : 'Set up'} {providerData[provider].description}
      </TextBody>
      <Spacer size="xlarge" />

      <TextBody size="small">Connection Name</TextBody>
      <Spacer size="2xsmall" />
      <Input value="Gemini Main" variant="outlined" />

      <Spacer />

      <TextBody size="small">API Key</TextBody>
      <Spacer size="2xsmall" />
      <Input
        value="AIzaSyD3m-Pb3Xy1Qe2FakeKeyForDemoPurposes"
        variant="outlined"
      />

      <Stack gutter="xsmall" justifyContent="end" slot="footer">
        <Button size="large" variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button size="large" onClick={onClose}>
          {isEdit ? 'Save' : 'Create'}
        </Button>
      </Stack>
    </GenericModal>
  );
};
